import React, { useState, useEffect } from 'react';
import { Menu, X, DollarSign } from 'lucide-react';

const Navbar: React.FC = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };

    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  const handleMenuClick = () => {
    setIsMenuOpen(false);
    // Add a small delay to allow the click event to complete
    setTimeout(() => {
      document.body.style.overflow = 'auto';
    }, 100);
  };

  useEffect(() => {
    // Prevent body scroll when menu is open
    document.body.style.overflow = isMenuOpen ? 'hidden' : 'auto';
    return () => {
      document.body.style.overflow = 'auto';
    };
  }, [isMenuOpen]);

  return (
    <nav 
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled ? 'bg-navy-900 shadow-lg py-3' : 'bg-transparent py-5'
      }`}
    >
      <div className="container mx-auto px-4">
        <div className="flex justify-between items-center">
          <div className="flex items-center">
            <div className="flex items-center mr-2 text-gold-500">
              <DollarSign size={28} />
            </div>
            <span className="text-white text-xl font-bold">AAbA Stable</span>
          </div>

          {/* Desktop Navigation */}
          <div className="hidden md:flex items-center space-x-8">
            <a href="#why" className="text-gray-200 hover:text-white transition-colors">
              Why AAbA Stable?
            </a>
            <a href="#advantages" className="text-gray-200 hover:text-white transition-colors">
              Your Advantage
            </a>
            <a href="#contact" className="text-gray-200 hover:text-white transition-colors">
              Contact
            </a>
            <a 
              href="#contact" 
              className="bg-gold-500 hover:bg-gold-600 text-navy-900 font-semibold px-5 py-2 rounded-md transition-colors"
            >
              Let's Connect
            </a>
          </div>

          {/* Mobile Navigation Toggle */}
          <div className="md:hidden">
            <button 
              onClick={() => setIsMenuOpen(!isMenuOpen)}
              aria-label="Toggle menu"
              className="text-white"
            >
              {isMenuOpen ? <X size={24} /> : <Menu size={24} />}
            </button>
          </div>
        </div>

        {/* Mobile Navigation Menu */}
        {isMenuOpen && (
          <div className="md:hidden fixed inset-0 top-[72px] bg-navy-900 z-50">
            <div className="flex flex-col space-y-4 p-4">
              <a 
                href="#why" 
                onClick={handleMenuClick}
                className="text-gray-200 hover:text-white transition-colors py-2"
              >
                Why AAbA Stable?
              </a>
              <a 
                href="#advantages" 
                onClick={handleMenuClick}
                className="text-gray-200 hover:text-white transition-colors py-2"
              >
                Your Advantage
              </a>
              <a 
                href="#contact" 
                onClick={handleMenuClick}
                className="text-gray-200 hover:text-white transition-colors py-2"
              >
                Contact
              </a>
              <a 
                href="#contact" 
                onClick={handleMenuClick}
                className="bg-gold-500 hover:bg-gold-600 text-navy-900 font-semibold px-5 py-2 rounded-md transition-colors inline-block w-fit"
              >
                Let's Connect
              </a>
            </div>
          </div>
        )}
      </div>
    </nav>
  );
};

export default Navbar;